export type GtmConfig = {
  auth: string;
  containerId: string;
  preview: string;
};

const googleTagEnv = process.env.NEXT_PUBLIC_GOOGLE_TAG_ENV;

export const GTM_CONFIGS = ((): { [_: string]: GtmConfig } => {
  switch (googleTagEnv) {
    case 'production':
      return {
        coubicFrontend: {
          auth: 'CXsKrbmeizWaaDt3OQhenA',
          containerId: 'GTM-MHRX774',
          preview: 'env-2',
        },
        coubicFrontend2: {
          auth: 'ppK0fcQWXybVZcdICBq2MA',
          containerId: 'GTM-WS64FTM',
          preview: 'env-2',
        },
      };
    case 'staging':
      return {
        coubicFrontendStaging: {
          auth: '60N0lrbFuaMSjWJtbZuzxw',
          containerId: 'GTM-PNBPHKZ',
          preview: 'env-2',
        },
        coubicFrontendStaging2: {
          auth: 'qj-_qgA8YLhy5RXC7R7BsA',
          containerId: 'GTM-TST7Z7M',
          preview: 'env-2',
        },
      };
    default:
      return {};
  }
})();

export type BookingEventArguments = {
  step: 'completion';
  resourcePublicId: string;
  reservationPublicId: number;
};
export const bookingEvent = ({
  step,
  resourcePublicId,
  reservationPublicId,
}: BookingEventArguments) => {
  if (window.gtag) {
    window.gtag('event', 'booking_rendered', {
      booking_step: step,
      res_id: resourcePublicId,
      rv_id: reservationPublicId,
    });
  }

  if (window.ga4tag) {
    const uri = new URL(window.location.href);

    // GA4 用のカスタムイベントのキー名称はマーチャントのオーナーが
    // アナリティクス管理の設定時に見ることのあるものなので、resourceという名前の露出を避けた名称にしています
    window.ga4tag('event', 'booking', {
      booking_step: step,
      reservation_page_id: resourcePublicId,
      reservation_id: reservationPublicId,
      URL: uri.href,
    });
  }
};

export type PurchaseEventArgument = {
  step: 'completion';
  productPublicId: string;
  customerPublicId: string | undefined;
};
export const purchaseEvent = ({
  step,
  productPublicId,
  customerPublicId,
}: PurchaseEventArgument) => {
  if (window.gtag) {
    window.gtag('event', 'purchase_rendered', {
      purchase_step: step,
      product_id: productPublicId,
      customer_id: customerPublicId,
    });
  }

  if (window.ga4tag) {
    const uri = new URL(window.location.href);

    window.ga4tag('event', 'purchase', {
      purchase_step: step,
      product_id: productPublicId,
      customer_id: customerPublicId,
      URL: uri.href,
    });
  }
};
